import { z } from 'zod';
var experimentExperienceEnum = z.enum(['search-page', 'quick-find', 'search-page-space-filter', 'quick-search', 'advanced-search']);
export var dynamicConfigSchema = z.string().transform(function (str, ctx) {
  try {
    return JSON.parse(str);
  } catch (e) {
    ctx.addIssue({
      code: 'custom',
      message: 'Invalid JSON'
    });
    return z.NEVER;
  }
}).pipe(z.object({
  layerType: z.string().startsWith('search_platform_layer_').optional(),
  statsigLayerId: z.string().startsWith('search_platform_'),
  entity: z.string().optional(),
  subEntity: z.string().optional(),
  hello: z.boolean().optional(),
  confluenceTier: z.string().array().optional(),
  productDataRegions: z.record(z.string(), z.string().array()).optional(),
  experiences: experimentExperienceEnum.array().optional(),
  tenantIds: z.string().array().optional(),
  targetingGateId: z.string().optional()
}));
export var dynamicExperimentsSchema = z.array(z.string()).transform(function (arrayJSONStrings) {
  return arrayJSONStrings.map(function (jsonStr) {
    return dynamicConfigSchema.safeParse(jsonStr).data;
  }).flatMap(function (dynamicConfig) {
    return dynamicConfig ? dynamicConfig : [];
  });
}).refine(function (dynamicConfig) {
  return dynamicConfig.length;
}); // The schema is invalid if all JSON strings are invalid